// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorTalkjs = (client) => ({
    /**
     * `GET /vendor/talkjs`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorTalkjsList
     * @source packages/modules/b2c-core/src/api/vendor/talkjs/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/talkjs", { method: "GET", query, headers }),
});
//# sourceMappingURL=talkjs.js.map